<template>
    <div id="containerLightbox">
        <lightbox-element
            v-for="hotspot in getHotspots"
            :key="hotspot['hotspotId']"
            :hotspot="hotspot"></lightbox-element>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import { ACTION_TYPE } from '@/playerVue3/enums/hotspot-enum';
import LightboxElement from "@/playerVue3/components/hotspot/lightbox-element.vue";

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const getHotspots = computed(() => {
    return store.getHotspotsByActionType(ACTION_TYPE.POPUP);
});

// METHODS

// LIFECYCLE HOOKS
</script>
